import { sendFirebaseEvent } from "./firebaseTracker";
import type {
  FirebaseEventName,
  FirebaseEventParamsMap,
  FirebaseScreenId,
} from "./types";

/**
 * 依頼書 §3 の共通計測モジュール。
 * 「今どの画面にいるか」を記録し、全イベントに source(遷移元の画面ID) を自動付与する。
 */

let currentScreen = "unknown";
let previousScreen = "unknown";

/**
 * 画面表示イベントを送信し、現在画面を更新する。
 * 画面IDは FIREBASE_SCREEN_ID の値のみ（クラス名・ルートパス禁止）。
 */
export const trackFirebaseScreenView = (screenId: FirebaseScreenId): void => {
  previousScreen = currentScreen;
  currentScreen = screenId;
  sendFirebaseEvent("screen_view", {
    screen_name: screenId,
    source: previousScreen,
  });
};

/**
 * Firebase Analytics イベントの送信エントリーポイント。
 * イベント名・パラメータは types.ts のイベント辞書で型強制され、source は自動で付く。
 */
export const trackFirebaseEvent = <K extends FirebaseEventName>(
  eventName: K,
  params: FirebaseEventParamsMap[K],
): void => {
  sendFirebaseEvent(eventName, { ...params, source: currentScreen });
};

/** テスト用: 画面状態をリセットする */
export const resetFirebaseScreenState = (): void => {
  currentScreen = "unknown";
  previousScreen = "unknown";
};
